/* eslint-disable no-irregular-whitespace */
/* eslint-disable no-useless-escape */
import { GeneralLayout } from '@/webapp/src/components/layout/GeneralLayout/index.js'
import { MDDoc } from '@/general/src/other/MDDoc/index.js'
import { withPageWrapper } from '@/webapp/src/lib/pageWrapper.js'

const md = `
# Договор-оферта о предоставлении неисключительного права использования программного обеспечения «СтрахоБот»

г. Самара

Дата публикации: 03 июля 2025 года

Общество с ограниченной ответственностью «СтрахоБот» (ОГРН 1256300016280, ИНН 6317170813, юридический адрес: 443004, Самарская область, г. Самара, ул. Нефтяников, д. 10А, кв. 5\) именуемое в дальнейшем «Исполнитель», действующее на основании Устава, публикует настоящую публичную оферту (далее — «Оферта») о заключении договора на предоставление неисключительного права использования программного обеспечения «СтрахоБот» (далее — «Договор», «ПО»).

Настоящая Оферта адресована физическим и юридическим лицам, индивидуальным предпринимателям (далее — «Пользователь»), и является официальным предложением ООО «СтрахоБот», именуемого в дальнейшем Исполнитель,   заключить Договор на изложенных ниже условиях.

Акцепт настоящей Оферты Пользователем является полным и безоговорочным принятием всех условий настоящего Договора без каких-либо изъятий или оговорок. С момента Акцепта Оферты Договор считается заключенным.

## 1\. Термины и определения

ПО — программное обеспечение «СтрахоБот», предоставляемое в виде облачного веб\-сервиса через сайт Исполнителя и предназначенное для автоматизации расчета и оформления страховых полисов.

Акцепт — полное и безоговорочное принятие Пользователем условий настоящей Оферты, выраженное в совершении любого из следующих действий: регистрации на сайте Исполнителя, оплаты выбранного Тарифа либо фактического начала использования ПО (в том числе активации функционала с использованием токенов). Акцепт Оферты влечёт заключение между Сторонами лицензионного договора в порядке статьи 438 Гражданского кодекса Российской Федерации.

Тариф — выбранный Пользователем пакет услуг, определяющий условия предоставления доступа к ПО, включая срок действия, количество токенов, доступный функционал и стоимость. Актуальные тарифы публикуются на сайте Исполнителя.

Токены — условные цифровые единицы, предоставляемые Пользователю исключительно для использования функционала ПО в рамках оплаченного Тарифа. Токены используются, в частности, для запуска операций по расчёту и/или оформлению страховых полисов. Токены не являются электронными денежными средствами, валютными ценностями, финансовыми инструментами или иными активами, не подлежат возврату, обмену, передаче третьим лицам и могут использоваться только в пределах срока действия соответствующего Тарифа. Неиспользованные токены аннулируются после окончания срока действия Тарифа, если иное прямо не предусмотрено условиями Тарифа.

Автоплатеж — функция автоматического списания денежных средств с платёжного средства Пользователя за очередной расчётный период в счёт продления оплаченного Тарифа. Автоплатеж может быть в любой момент отключён Пользователем через интерфейс ПО или по письменному обращению к Исполнителю.

## 2\. Предмет Договора

2.1. Исполнитель предоставляет Пользователю неисключительное (простое) право использования программного обеспечения «СтрахоБот» (далее — ПО) в форме ограниченной лицензии, исключительно для личного или коммерческого использования в рамках функционала ПО и в соответствии с выбранным Тарифом. Право использования предоставляется без права передачи, уступки, сублицензирования, копирования, модификации или распространения ПО. Пользователь обязуется своевременно оплачивать стоимость предоставляемых прав и соблюдать все условия настоящего Договора.

2.2. Предоставление неисключительного права использования ПО не влечёт за собой перехода к Пользователю каких-либо исключительных прав на ПО, включая, но не ограничиваясь, правом на воспроизведение, переработку, распространение, публичный показ, декомпиляцию, реверс-инжиниринг, а также доступ к исходному коду.

 

## 3\. Порядок заключения Договора

3.1. Настоящий Договор считается заключённым с момента Акцепта Пользователем настоящей Оферты. Акцептом признаются совершение Пользователем любых из следующих действий: регистрация на сайте Исполнителя, оплата выбранного Тарифа либо иное фактическое использование функционала ПО, свидетельствующее о согласии с условиями настоящей Оферты.

3.2. Акцепт настоящей Оферты Пользователем является полным и безоговорочным принятием всех условий настоящего Договора без каких-либо изъятий или оговорок и в соответствии со статьёй 438 Гражданского кодекса Российской Федерации равносилен заключению двустороннего письменного договора.

 

## 4\. Права и обязанности сторон

4.1. Пользователь имеет право:

• использовать ПО в пределах выбранного Тарифа, количества предоставленных Токенов и доступного функционала, при условии соблюдения условий настоящего Договора;

• приобретать дополнительные Токены в соответствии с условиями, размещёнными на сайте Исполнителя;

• отказаться от функции Автоплатежа в любой момент через интерфейс ПО или путём направления письменного уведомления Исполнителю.

4.2. Пользователь обязуется:

• использовать ПО исключительно по его назначению, в пределах предоставленных прав и в соответствии с действующим законодательством Российской Федерации;

• не передавать логины, пароли, ключи доступа или иные элементы аутентификации третьим лицам, а также не предоставлять третьим лицам доступ к ПО и его функционалу;

• своевременно и в полном объёме производить оплату в соответствии с выбранным Тарифом;

• не предпринимать действий, направленных на обход или модификацию систем защиты ПО, нарушение его работоспособности, или получения несанкционированного доступа к функционалу;

• не осуществлять реверс-инжиниринг, декомпиляцию, дизассемблирование, копирование, модификацию, воспроизведение ПО либо его элементов, а также не создавать производные продукты на основе ПО.

4.3. Исполнитель имеет право:

• временно приостанавливать доступ к ПО для проведения профилактических или технических работ, уведомив Пользователя не менее чем за 3 (три) календарных дня до планируемой даты приостановки, за исключением случаев аварийного обслуживания;

• изменять условия настоящей Оферты, а также содержание, структуру и функционал ПО, с обязательной публикацией новой редакции на сайте не менее чем за 30 (тридцать) календарных дней до вступления изменений в силу;

• заблокировать доступ Пользователя к ПО и аннулировать неиспользованные Токены в случае нарушения Пользователем условий настоящего Договора, в том числе в случае несанкционированного доступа, вмешательства в работу ПО, либо использования ПО в противоправных целях;

• вести учёт действий Пользователя в автоматизированной системе с целью обеспечения безопасности и контроля соблюдения условий Договора.

 

4.4. Исполнитель обязуется:

• предоставить Пользователю доступ к ПО в течение 1 (одного) рабочего дня с момента поступления полной оплаты соответствующего Тарифа;

• принимать разумные меры для обеспечения бесперебойной работы ПО и своевременного устранения технических сбоев;

• обеспечивать конфиденциальность и защиту персональных данных Пользователя в соответствии с законодательством Российской Федерации и Политикой конфиденциальности, опубликованной на сайте Исполнителя.

 

## 5\. Стоимость услуг и порядок расчетов

5.1. Стоимость предоставления неисключительного права использования ПО определяется в соответствии с Тарифом, выбранным Пользователем, и указывается на сайте Исполнителя в момент оформления заказа. Все расчёты производятся в российских рублях.

5.2. Оплата осуществляется на условиях 100% (сто процентной) предоплаты. Доступ к функционалу ПО предоставляется только после подтверждения получения оплаты Исполнителем.

5.3. В случае подключения функции Автоплатежа, денежные средства автоматически списываются с платёжного средства Пользователя ежемесячно (или в иной расчётный период, указанный в условиях Тарифа), до момента отключения функции Автоплатежа самим Пользователем или по письменному уведомлению Исполнителя.

5.4. Возврат денежных средств возможен исключительно в следующих случаях:

• при ошибочном зачислении средств (например, дублирующемся платеже);

• при обращении Пользователя с требованием о возврате не позднее 3 (трёх) календарных дней после осуществления Автосписания, при условии, что в указанный период Пользователь не начал использовать ПО (не авторизовался и не производил действий, ведущих к списанию токенов).

5.5. Возврат денежных средств осуществляется только на то же платёжное средство, с которого была произведена оплата, в срок до 10 (десяти) рабочих дней с момента удовлетворения требования о возврате.

5.6. Исполнитель вправе по своему усмотрению предоставлять Пользователю доступ к ограниченному функционалу ПО в рамках пробного (тестового) режима. Такой доступ может сопровождаться техническим списанием с платёжного средства Пользователя суммы в размере 1 (одного) рубля с последующим автоматическим возвратом. Указанное списание не считается оплатой услуг и используется исключительно для подтверждения работоспособности платёжного средства. Наличие или предоставление пробного режима не является обязанностью Исполнителя.

 

## 6\. Ответственность сторон

6.1. ПО предоставляется в состоянии «как есть» (as is). Исполнитель не даёт гарантий того, что ПО будет соответствовать индивидуальным целям, задачам или ожиданиям Пользователя.

6.2. Исполнитель не несет ответственности за убытки Пользователя, возникшие вследствие действий третьих лиц или нарушений условий Договора самим Пользователем.

6.3. Общая ответственность Исполнителя по настоящему Договору ограничивается суммой, фактически уплаченной Пользователем за последний расчётный период, в течение которого возникло событие, повлёкшее ответственность.

6.5. Стороны освобождаются от ответственности за частичное или полное неисполнение обязательств по настоящему Договору, если оно вызвано действием непреодолимой силы (форс-мажором), включая, но не ограничиваясь: сбоями в работе интернета, отказами оборудования, массовыми техническими сбоями, хакерскими атаками, природными катастрофами, военными действиями, изменениями законодательства или нормативных требований, препятствующих исполнению Договора.

 

## 7\. Персональные данные

7.1. Пользователь выражает согласие на обработку своих персональных данных в целях исполнения настоящего Договора, а также для предоставления доступа к функционалу ПО, в соответствии с Федеральным законом от 27.07.2006 № 152ФЗ «О персональных данных».

7.2. Порядок обработки персональных данных, перечень обрабатываемых данных, цели и иные условия определяются Политикой конфиденциальности и Согласием на обработку персональных данных, размещёнными на сайте Исполнителя.

7.3. Акцепт настоящей Оферты подтверждает ознакомление Пользователя с указанными документами и является полным и осознанным согласием на обработку персональных данных в установленном ими объёме.

## 8\. Заключительные положения

8.1. К отношениям сторон, возникающим в связи с настоящим Договором, применяется право Российской Федерации.

8.2. Все споры, разногласия и требования, возникающие из настоящего Договора или в связи с ним, подлежат разрешению в претензионном порядке. Сторона, чьи права нарушены, направляет другой Стороне письменную претензию. Срок рассмотрения претензии — 10 (десять) рабочих дней с момента её получения.

8.3. В случае невозможности урегулирования спора в претензионном порядке, спор подлежит рассмотрению в судебном порядке в соответствии с законодательством Российской Федерации в суде по месту нахождения Исполнителя.

8.4. Настоящая Оферта вступает в силу с момента её публикации на сайте Исполнителя и действует до момента её отзыва либо замены новой редакцией.

8.5. Актуальная редакция Оферты размещена на сайте Исполнителя.

 

## Реквизиты Исполнителя:

Общество с ограниченной ответственностью «СтрахоБот»

Адрес: 443004, Самарская область, г. Самара, ул. Нефтяников, д. 10А, кв. 5

ОГРН 1256300016280

ИНН 6317170813

КПП 631701001

Расчетный счет 40702810810001932509

ОГРН/ОГРНИП 1256300016280

Банк АО «ТБанк»

БИК банка 044525974

ИНН банка 7710140679

Корреспондентский счет банка 30101810145250000974

Юридический адрес банка 127287, г. Москва, ул. Хуторская 2-я, д. 38А, стр. 26

Адрес электронной почты: manager@strahobot.ru

Телефон: 89277938138

 

 


`

export const DocOfertaPage = withPageWrapper({
  title: 'Договор-оферта',
  Layout: GeneralLayout,
})(() => {
  return <MDDoc md={md} />
})
